import React from "react";
import Badge from "../../shared/badge";
import { Collapse } from "antd";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
const { Panel } = Collapse;

const Faqs = () => {
  const { t } = useTranslation();

  const accordionItems = [
    {
      key: "1",
      header: "How does Kameleon Law help streamline legal processes?",
      content:
        "Kameleon Law uses advanced AI to automate legal workflows, document processing, and case management, saving you time and reducing manual work.",
    },
    {
      key: "2",
      header: "Is my data secure on Kameleon Law?",
      content:
        "Yes, we prioritize security with end-to-end encryption, strict access controls, and compliance with industry standards to keep your legal data safe.",
    },
    {
      key: "3",
      header: "Can I integrate Kameleon Law with other tools?",
      content:
        "Absolutely! Kameleon Law supports integration with popular legal and productivity tools, ensuring a seamless workflow for your practice.",
    },
    {
      key: "4",
      header: "Does Kameleon Law support multiple users?",
      content:
        "Yes, law firms and teams can collaborate efficiently with multi-user access, role-based permissions, and centralized case management.",
    },
    {
      key: "5",
      header: "How does AI help with contract management?",
      content:
        "Our AI automatically categorizes, analyzes, and tracks contracts, alerting you about key deadlines and clauses to ensure compliance and efficiency.",
    },
  ];

  return (
    <>
      <div className="faqs-main w-100 bg-[#F0F2F4] rounded-[38px] py-[70px]">
        <div className="faq-inner w-[80%] m-auto flex flex-col items-center gap-[58px] max-xxxl:w-[90%]">
          <div className="flex flex-col gap-[20px]">
            <Badge txt={t("home.faqs.title")} />
            <h2 className="max-w-[528px] leading-[70px] tracking-[-3px] font-sora">
              {t("home.faqs.subtitle")}
            </h2>
          </div>

          <div className="accordion-wrapper w-full ">
            <Collapse
              expandIconPosition="right"
              expandIcon={({ isActive }) =>
                isActive ? (
                  <img src="../../assets/icons/faqArrowUp.png" alt="icon" />
                ) : (
                  <img src="../../assets/icons/faqArrowRight.png" alt="icon" />
                )
              }
              ghost
              className="custom-collapse flex gap-[84px] flex-col"
            >
              {accordionItems.map((item) => (
                <Panel
                  key={item.key}
                  header={
                    <>
                      <div className=" absolute top-[-78px] left-[-43px] sm-s:left-[-20px] sm-s:top-[-63px]">
                        <img
                          src="../../assets/images/about/faqTop.svg"
                          alt=""
                        />
                        <div className="number-icon absolute top-[30%] left-[17%] w-[38px] h-[38px] sm-s:w-[28px] sm-s:h-[28px] flex justify-center items-center light-blue-color rounded-[26px] border-[1px] border-solid border-[#0bd]">
                          <h6 className="font-bold leading-[24px] sm-s:text-[14px]">
                            {item.key}
                          </h6>
                        </div>
                      </div>
                      <div className="flex items-center justify-between relative ">
                        <h6 className="font-bold sm-s:text-[16px]">
                          {item.header}
                        </h6>
                      </div>
                    </>
                  }
                >
                  <p className="text-[#28292E] pt-[48px] font-medium large leading-[24px] tracing-[0.9px]">
                    {item.content}
                  </p>
                </Panel>
              ))}
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faqs;
